// extracted by mini-css-extract-plugin
export default {"surveyFlex":"CreatorSurveyModal_surveyFlex__YxFs4"};